export const isExtensionRuntime = (): boolean =>
  typeof chrome !== "undefined" && Boolean(chrome.runtime?.id);
